import React, { useEffect, useRef, useMemo } from 'react'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { EmployeeDataHoc } from '../../utils/hocs'
import { MisSingleSelect } from '../common/atoms'
import { successOrFailureToaster } from '../common/atoms/messages'
import { SALES_ROLE } from '../../constants/overview'
import { dropdownDownArrow, dropdownUpArrow } from '../../assets/images'
import { MultiSelect } from 'react-multi-select-component'
import MisApi from '../../services/mis.api'
import ToggleButton from '../common/atoms/ToggleButton'
import utilizationApi from '../../services/utilization.api'
import { OPD_HEADER_MULTISELECT_OPTIONS, opdHeaderLabelByKey } from '../../constants/opdMisPulseHeaders'
import { dsButtonPrimary, dsButtonSecondary, joinButtonClasses } from '../../utils/buttonStyles'
import CompanySearchSelect from '../common/molecules/CompanySearchSelect'

const FREQUENCY_OPTIONS = Object.freeze(['daily', 'weekly', 'monthly'])
const DAYS_OF_MONTH = Object.freeze([...Array(31).keys()].map((i) => i + 1))

const sortOptionsWithSelectedFirst = (options, selected) => {
  if (!selected?.length) return options
  const selectedSet = new Set(selected.map((s) => String(s.value)))
  const selectedFirst = []
  const rest = []
  for (const opt of options) {
    if (selectedSet.has(String(opt.value))) selectedFirst.push(opt)
    else rest.push(opt)
  }
  return [...selectedFirst, ...rest]
}

const sortDataWithValueFirst = (data, value) => {
  if (value === '' || value === undefined || value === null) return data
  const idx = data.findIndex((item) => String(item) === String(value))
  if (idx <= 0) return data
  return [data[idx], ...data.slice(0, idx), ...data.slice(idx + 1)]
}

const sortPulseTypeSelectArrays = (pulseOptions, pulseType) => {
  const idx = pulseOptions.findIndex((o) => o.value === pulseType)
  if (idx <= 0) {
    return {
      labels: pulseOptions.map((o) => o.label),
      values: pulseOptions.map((o) => o.value)
    }
  }
  const rotated = [...pulseOptions.slice(idx), ...pulseOptions.slice(0, idx)]
  return {
    labels: rotated.map((o) => o.label),
    values: rotated.map((o) => o.value)
  }
}

const AddMisPulse = (props) => {
  const buildSidsFromEdit = (d) =>
    d?.companies?.length
      ? d.companies.map((c) => ({ value: c.id, label: c.name || String(c.id) }))
      : (d?.sids || []).map((id) => ({ value: id, label: String(id) }))

  const [editMisId] = useState(props.location.state?.data?.id)
  const [editMisData, setEditMisData] = useState(props.location.state?.data)
  const [state, setState] = useState({
    name: '',
    sids: [],
    contract_ids: [],
    benefits: [],
    frequency: '',
    mappings: [],
    opd_mappings: [],
    emails: '',
    day_of_week: '',
    day_of_month: '',
    reimbursement: false,
    cashless: false,
    pulse_type: 'opd_utilization'
  })
  const [contractOptions, setContractOptions] = useState([])
  const [benefitOptions, setBenefitOptions] = useState([])
  const isEditMode = Boolean(editMisId)
  const pageTitle = isEditMode ? 'Edit Mis Pulse' : 'Add Mis Pulse'
  let history = useHistory()
  const days_mapping = [{ id: '0', label: 'Sunday' }, { id: '1', label: 'Monday' }, { id: '2', label: 'Tuesday' }, { id: '3', label: 'Wednesday' }, { id: '4', label: 'Thursday' }, { id: '5', label: 'Friday' }, { id: '6', label: 'Saturday' }]
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

  const mappings = [
    'ek_id', 'email', 'name', 'patient_name', 'main_customer_name', 'policy_number', 'member_id', 'age', 'active', 'guardian_ek_id', 'relation', 'parent_company_id', 'sponsor',
    'sponsor_name', 'employee_id', 'vip', 'registered_time', 'appointment_id',
    'appointment_date', 'appointment_time', 'appointment_type', 'appointment_status', 'masked_package_name',
    'tagging', 'package_id', 'package_name', 'package_type', 'package_payment_type', 'enterprise_id',
    'provider_id', 'diagnostic_center', 'dc_branch_name', 'provider_city', 'provider_state', 'mrp', 'selling_price', 'invoice_amount',
    'pending_tests', 'medical_records_count', 'rating', 'comment',
    'options', 'package_tests', 'customer_type', 'gender', 'date_of_birth', 'department', 'invoice_date', 'reports_received_date',
    'first_report_received_date', 'confirmed_time', 'request_date', 'request_status', 'speciality', 'enterprise_name', 'created_at', 'updated_at',
    'amount', 'booking_id',     'month_year_of_invoice', 'month_day_year_of_invoice', 'provider_name', 'company_name', 'guardian_email', 'grade',
    'wallet_amount', 'contract_start_date', 'contract_end_date'
  ]

  const optionsMapping = (options) => options.map((p) => ({ value: p, label: p }));
  const mapIdsToOptions = (ids = [], options = []) => {
    const optionLabelByValue = new Map(options.map((option) => [String(option.value), option.label]))

    return ids.map((id) => ({
      value: id,
      label: optionLabelByValue.get(String(id)) || `${id}`
    }))
  }

  const mapping_option = optionsMapping(mappings);
  const pulseTypeOptions = [
    { label: 'Utilization', value: 'utilization_v2' },
    { label: 'OPD', value: 'opd_v2' },
    { label: 'Both', value: 'opd_utilization' }
  ]

  const CustomItemRenderer = ({
    checked,
    option,
    onClick,
    disabled,
  }) => (
    <div className={`item-renderer ${disabled ? 'disabled' : 'font-heavy items-center'}`}
      style={{ display: 'flex', alignItems: 'center' }}>
      <div >
        <input
          className='p-8'
          type='checkbox'
          onChange={onClick}
          checked={checked}
          tabIndex={-1}
          disabled={disabled}
        />
      </div>
      <div>
        <span style={{ verticalAlign: 'middle', marginTop: '3px', display: 'flex', alignItems: 'center' }}>{option.label}</span></div>
    </div>
  );

  const setSubState = (newState) => {
    setState(prevState => { return { ...prevState, ...newState } })
  }

  const inputRef = useRef();
  const prevSidRef = useRef(null)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.style.setProperty('--placeholder-color', '#9CA3AF');
    }
  }, []);

  useEffect(() => {
    if (editMisData?.sids?.length) {
      setSubState({ sids: buildSidsFromEdit(editMisData) })
    } else {
      const cached = JSON.parse(sessionStorage.getItem('companies') || '[]')
      if (cached.length > 0) {
        setSubState({ sids: [{ value: cached[0].id, label: cached[0].name || String(cached[0].id) }] })
      }
    }
  }, []);

  useEffect(() => {
    if (state.sids.length > 1) {
      prevSidRef.current = null
      setSubState({ contract_ids: [], benefits: [] })
      return
    }

    if (state.sids.length === 1) {
      const sid = state.sids[0].value
      if (prevSidRef.current !== null && prevSidRef.current !== sid) {
        setSubState({ contract_ids: [], benefits: [] })
      }
      prevSidRef.current = sid

      utilizationApi.fetchContracts(
        { params: { company_id: sid } },
        (resp) => {
          const contracts = (resp.data || []).map((contract) => ({
            value: contract.id,
            label: `${contract.start_date} - ${contract.end_date}`
          }))
          setContractOptions(contracts)
        },
        () => setContractOptions([])
      )
    }
  }, [state.sids]);

  useEffect(() => {
    if (state.sids.length !== 1) {
      return
    }
    if (state.contract_ids.length !== 1) {
      setBenefitOptions([])
      return
    }

    utilizationApi.fetchUtilizationBenefitList(
      {
        companyId: state.sids[0].value,
        contractId: state.contract_ids[0].value,
        misPulse: true
      },
      (resp) => {
        const options = (resp.data?.benefits || []).map((benefit) => ({
          value: benefit.benefit_type,
          label: benefit.benefit_name
        }))
        setBenefitOptions(options)
        setState((prev) => ({
          ...prev,
          benefits: prev.benefits.filter((b) => options.some((o) => o.value === b.value))
        }))
      },
      () => setBenefitOptions([])
    )
  }, [state.sids, state.contract_ids]);

  useEffect(() => {
    if (state.contract_ids.length > 1) {
      setSubState({ benefits: [] })
    }
  }, [state.contract_ids]);

  useEffect(() => {
    if (editMisData) {
      setState({
        name: editMisData.name || '',
        sids: buildSidsFromEdit(editMisData),
        contract_ids: mapIdsToOptions(editMisData.contract_ids || [], contractOptions),
        benefits: mapIdsToOptions(editMisData.benefits || [], benefitOptions),
        frequency: editMisData.frequency,
        mappings: editMisData.mappings.map((m) => ({ value: m, label: m })),
        opd_mappings: (editMisData.opd_mappings || []).map((m) => ({
          value: m,
          label: opdHeaderLabelByKey[m] || m
        })),
        emails: editMisData.emails.join(', '),
        day_of_week: days_mapping.find((d) => d.id === editMisData.day_of_week)?.label || '',
        day_of_month: editMisData.day_of_month || '',
        reimbursement: editMisData.reimbursement,
        cashless: editMisData.cashless,
        pulse_type: editMisData.pulse_type
      });
    }
  }, [editMisData]);

  useEffect(() => {
    if (contractOptions.length === 0 || state.contract_ids.length === 0) {
      return
    }

    const optionLabelByValue = new Map(contractOptions.map((option) => [String(option.value), option.label]))
    let hasLabelChanges = false

    const normalizedContracts = state.contract_ids.map((selectedContract) => {
      const normalizedLabel = optionLabelByValue.get(String(selectedContract.value))
      if (!normalizedLabel || selectedContract.label === normalizedLabel) {
        return selectedContract
      }

      hasLabelChanges = true
      return { ...selectedContract, label: normalizedLabel }
    })

    if (hasLabelChanges) {
      setSubState({ contract_ids: normalizedContracts })
    }
  }, [contractOptions, state.contract_ids]);

  useEffect(() => {
    if (benefitOptions.length === 0 || state.benefits.length === 0) {
      return
    }

    const optionLabelByValue = new Map(benefitOptions.map((option) => [String(option.value), option.label]))
    let hasLabelChanges = false

    const normalizedBenefits = state.benefits.map((selectedBenefit) => {
      const normalizedLabel = optionLabelByValue.get(String(selectedBenefit.value))
      if (!normalizedLabel || selectedBenefit.label === normalizedLabel) {
        return selectedBenefit
      }

      hasLabelChanges = true
      return { ...selectedBenefit, label: normalizedLabel }
    })

    if (hasLabelChanges) {
      setSubState({ benefits: normalizedBenefits })
    }
  }, [benefitOptions, state.benefits]);

  const onSave = async () => {
    const isOpdOnly = state.pulse_type === 'opd_v2'
    const isUtilizationOnly = state.pulse_type === 'utilization_v2'

    const mis_pulse = {
      ...state,
      sids: state.sids.map((s) => s.value),
      contract_ids: state.contract_ids.map((c) => c.value),
      benefits: state.benefits.map((b) => b.value),
      mappings: isOpdOnly ? [] : state.mappings.map((m) => m.value),
      opd_mappings: isUtilizationOnly ? [] : state.opd_mappings.map((m) => m.value),
      day_of_week: days_mapping.find((d) => d.label === state.day_of_week)?.id || null,
    };

    const apiFunction = editMisId ? MisApi.updateMisPulse : MisApi.createMisPulse;

    apiFunction(
      { data: { mis_pulse }, id: editMisId },
      (res) => {
        successOrFailureToaster({ message: editMisId ? 'Mis Pulse updated successfully' : 'Mis Pulse created successfully' });
        history.push('/mis-pulse');
      },
      (err) => {
        const data = err?.response?.data
        const msg = data?.message || data?.msg || data?.error || err?.message || 'Operation failed'
        successOrFailureToaster({ message: msg, type: 'fail' });
      }
    );
  };

  const formHandler = (event) => {
    let name = '', value = ''
    name = event.name
    value = event.value
    if (name === 'frequency' && value === 'daily') {
      setSubState({ frequency: value, day_of_week: '', day_of_month: '' })
      return
    }
    if (name === 'pulse_type') {
      if (value === 'opd_v2') {
        setSubState({ pulse_type: value, mappings: [] })
        return
      }

      if (value === 'utilization_v2') {
        setSubState({ pulse_type: value, opd_mappings: [] })
        return
      }
    }

    setSubState({ [name]: value })
  }

  const ArrowRenderer = ({ expanded }) => <img src={expanded ? dropdownUpArrow : dropdownDownArrow} />;
  const defaultCompanyIds = useMemo(() => {
    if (editMisData?.sids?.length) return editMisData.sids
    const cached = JSON.parse(sessionStorage.getItem('companies') || '[]')
    return cached[0]?.id ? [cached[0].id] : []
  }, []);
  const initialCompanyOptions = useMemo(() => editMisData?.companies || [], []);
  const isBenefitSelectionDisabled = state.sids.length > 1 || state.contract_ids.length > 1
  const isOpdOnly = state.pulse_type === 'opd_v2'
  const isUtilizationOnly = state.pulse_type === 'utilization_v2'
  const isBoth = state.pulse_type === 'opd_utilization'
  const isUtilizationMappingsDisabled = isOpdOnly
  const isOpdMappingsDisabled = isUtilizationOnly
  const selectedPulseTypeLabel = pulseTypeOptions.find((option) => option.value === state.pulse_type)?.label || ''
  const pulseTypeSelectArrays = sortPulseTypeSelectArrays(pulseTypeOptions, state.pulse_type)

  return (
    <React.Fragment>
      <EmployeeDataHoc
        classes='pb-32'
        title={pageTitle}
        breadcrumb={[{ text: 'Mis pulse', link: '/mis-pulse' }, { text: pageTitle, link: '#' }]}
        close={() => history.goBack()}
      >
        <h1 className='text-sm font-semibold tracking-widest leading-3 text-gray-500 mt-6 mb-3'>DETAILS</h1>
        <div className='bg-white rounded-md border'>
          <div className='grid grid-cols-2 gap-x-4 gap-y-6 p-6'>
            <div className='flex justify-start'>
              <div className='w-full text-gray-500'>
                <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'>NAME</div>
                <input type='text' name='name' value={state.name} placeholder='Enter MIS pulse name'
                       onChange={(e) => formHandler({ name: 'name', value: e.target.value })}
                       className='text-sm bg-gray-100 border text-gray-500 border-gray-200 pl-5 rounded-md w-full h-12 placeholder-gray-300' />
              </div>
            </div>
            <MisSingleSelect
              onChangeHandler={formHandler}
              value={state.frequency}
              data={sortDataWithValueFirst(FREQUENCY_OPTIONS, state.frequency)}
              name='frequency'
              placeholder='Select'
              label='FREQUENCY'
              labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'
              listClasses='z-20'
              listItemClasses='capitalize px-4 py-2'
              bgColor='bg-gray-100 capitalize'
              placeholderClasses='h-4'
            />
            {state.frequency === 'weekly' && <MisSingleSelect
              onChangeHandler={formHandler}
              value={state.day_of_week}
              data={sortDataWithValueFirst(days, state.day_of_week)}
              name='day_of_week'
              placeholder='Select'
              label='DAY OF WEEK'
              labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'
              listClasses='z-20'
              listItemClasses='capitalize px-4 py-2'
              bgColor='bg-gray-100 capitalize'
              placeholderClasses='h-4'
            />}
            {state.frequency === 'monthly' && <MisSingleSelect
              onChangeHandler={formHandler}
              value={state.day_of_month}
              data={sortDataWithValueFirst(DAYS_OF_MONTH, state.day_of_month)}
              name='day_of_month'
              placeholder='Select'
              label='DAY OF MONTH'
              labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'
              listClasses='z-20'
              listItemClasses='capitalize px-4 py-2'
              bgColor='bg-gray-100 capitalize'
              placeholderClasses='h-4'
            />}
            <div>
              <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'>
                COMPANY
              </div>
              <CompanySearchSelect
                mode='multi'
                value={state.sids.map((s) => s.value)}
                initialIds={defaultCompanyIds}
                initialOptions={initialCompanyOptions}
                onChange={(val, companies) => {
                  setSubState({ sids: companies.map((c) => ({ value: c.id, label: c.name || String(c.id) })) })
                }}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'>
                CONTRACTS
              </div>
              <div className='font-semibold  text-gray-500 cursor-pointer'>
                <MultiSelect
                  className="mis"
                  options={sortOptionsWithSelectedFirst(contractOptions, state.contract_ids)}
                  value={state.contract_ids}
                  onChange={(e) => formHandler({ name: 'contract_ids', value: e })}
                  disabled={state.sids.length > 1}
                  labelledBy='Select'
                  ItemRenderer={CustomItemRenderer}
                  ArrowRenderer={ArrowRenderer}
                  overrideStrings={{ 'selectSomeItems': 'Select' }}
                />
              </div>
              {state.sids.length > 1 && <div className='text-xs mt-2 text-gray-500'>For multiple companies, only current contract data will be shared.</div>}
            </div>
            <div>
              <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'>
                BENEFITS
              </div>
              <div className='font-semibold  text-gray-500 cursor-pointer'>
                <MultiSelect
                  className="mis"
                  options={sortOptionsWithSelectedFirst(benefitOptions, state.benefits)}
                  value={state.benefits}
                  onChange={(e) => formHandler({ name: 'benefits', value: e })}
                  disabled={isBenefitSelectionDisabled}
                  labelledBy='Select'
                  ItemRenderer={CustomItemRenderer}
                  ArrowRenderer={ArrowRenderer}
                  overrideStrings={{ 'selectSomeItems': 'Select' }}
                />
              </div>
              {isBenefitSelectionDisabled && <div className='text-xs mt-2 text-gray-500'>For multiple companies/contracts, all eligible benefits will be shown.</div>}
            </div>
            <div className='flex justify-start'>
              <div className='w-full text-gray-500 '>
                <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3 '>EMAILS</div>
                <div className='text-gray-500'>
                  <input type='text' name='emails' value={state.emails} placeholder='Add emails' onChange={(e) => formHandler({ name: 'emails', value: e.target.value })} className={`text-sm bg-gray-100 border text-gray-500 border-gray-200 pl-5 rounded-md w-full h-12 placeholder-gray-300`} />
                </div>
              </div>
            </div>
             <MisSingleSelect
              onChangeHandler={formHandler}
              value={selectedPulseTypeLabel}
              data={pulseTypeSelectArrays.labels}
              values={pulseTypeSelectArrays.values}
              name='pulse_type'
              placeholder='Select'
              label='PULSE TYPE'
              labelClasses='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'
              listClasses='z-20'
              listItemClasses='capitalize px-4 py-2'
              bgColor='bg-gray-100 capitalize'
              placeholderClasses='h-4'
            />
            <div>
              <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'>
                UTILIZATION HEADERS
              </div>
              <div className='font-semibold text-gray-500 cursor-pointer'>
                <MultiSelect
                  className="mis"
                  options={sortOptionsWithSelectedFirst(mapping_option, state.mappings)}
                  value={state.mappings}
                  onChange={(e) => formHandler({ name: 'mappings', value: e })}
                  disabled={isUtilizationMappingsDisabled}
                  labelledBy='Select'
                  ItemRenderer={CustomItemRenderer}
                  ArrowRenderer={ArrowRenderer}
                  overrideStrings={{ 'selectSomeItems': 'Select' }}
                />
              </div>
              {!isBoth && isUtilizationMappingsDisabled && <div className='text-xs mt-2 text-gray-500'>Only applicable for Both/Utilization pulse type.</div>}
            </div>
            <div>
              <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mb-3'>
                OPD HEADERS
              </div>
              <div className='font-semibold text-gray-500 cursor-pointer'>
                <MultiSelect
                  className="mis"
                  options={sortOptionsWithSelectedFirst(OPD_HEADER_MULTISELECT_OPTIONS, state.opd_mappings)}
                  value={state.opd_mappings}
                  onChange={(e) => formHandler({ name: 'opd_mappings', value: e })}
                  disabled={isOpdMappingsDisabled}
                  labelledBy='Select'
                  ItemRenderer={CustomItemRenderer}
                  ArrowRenderer={ArrowRenderer}
                  overrideStrings={{ 'selectSomeItems': 'Select' }}
                />
              </div>
              {!isBoth && isOpdMappingsDisabled && <div className='text-xs mt-2 text-gray-500'>Only applicable for Both/OPD pulse type.</div>}
            </div>
          </div>
          <div className='flex flex-row flex-wrap justify-start items-center p-6 border-t'>
            <div className="ml-6 flex items-center text-center mb-4">
              <div className="text-xs font-semibold tracking-widest leading-3 text-gray-500 mr-4">
                REIMBURSEMENT
              </div>
              <span className={`px-2.5 relative hover:bg-blue-100 self-center pt-2 pb-1 2xl:pt-2.5 2xl:pb-1.5 rounded-md`}> <ToggleButton name='reimbursement' toggle={state.reimbursement} onChangeHandler={(e) => formHandler(e)} /></span>
            </div>
            <div className="ml-6 flex items-center text-center mb-4">
              <div className="text-xs font-semibold tracking-widest leading-3 text-gray-500 mr-4">
                CASHLESS
              </div>
              <span className={`px-2.5 relative hover:bg-blue-100 self-center pt-2 pb-1 2xl:pt-2.5 2xl:pb-1.5 rounded-md`}> <ToggleButton name='cashless' toggle={state.cashless} onChangeHandler={(e) => formHandler(e)} /></span>
            </div>
          </div>
          <div className='p-4 text-right border' style={{ backgroundColor: '#EFF6FF' }}>
            <button className={joinButtonClasses(dsButtonSecondary, 'h-11 px-6')} onClick={() => history.goBack()}>
              Cancel
            </button>
            <button type='submit' disabled={SALES_ROLE === 'sales'} className={joinButtonClasses(dsButtonPrimary, 'ml-3 h-11 px-6', SALES_ROLE === 'sales' && 'cursor-not-allowed')} onClick={onSave}>
              {editMisId ? 'Update' : 'Save'}
            </button>
          </div>
        </div>
      </EmployeeDataHoc>
    </React.Fragment>
  )
}

export default AddMisPulse
